function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import isObject from 'lodash/isObject';
import cn from 'classnames';
import intlShape from 'shapes/intlShape';
var _React_PureComponent;
class Tag extends (_React_PureComponent = React.PureComponent) {
    onClick(evt, isEnabled) {
        if (!isEnabled) {
            evt.preventDefault();
            return;
        }
        this.props.onClick(evt);
    }
    get title() {
        const { titleMessage } = this.props;
        if (!titleMessage) {
            return null;
        }
        if (isObject(titleMessage)) {
            return this.props.intl.formatMessage(titleMessage);
        }
        return titleMessage;
    }
    render() {
        return /*#__PURE__*/ _jsx("button", {
            type: "button",
            id: this.props.id,
            className: cn('tag', {
                'tag--disabled': this.props.isDisabled,
                'tag--active': this.props.isActive
            }, this.props.className),
            disabled: this.props.isDisabled,
            onClick: (evt)=>this.onClick(evt, !this.props.isDisabled),
            title: this.title,
            children: this.title
        });
    }
}
_define_property(Tag, "propTypes", {
    titleMessage: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    onClick: PropTypes.func,
    intl: intlShape.isRequired,
    className: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    isDisabled: PropTypes.bool,
    isActive: PropTypes.bool,
    id: PropTypes.string
});
_define_property(Tag, "defaultProps", {
    isDisabled: false,
    isActive: false,
    onClick: ()=>{}
});
export default injectIntl(Tag);
